import { render, staticRenderFns } from "./mobile_CaseDemonstration.vue?vue&type=template&id=1b460b1b&scoped=true"
import script from "./mobile_CaseDemonstration.vue?vue&type=script&lang=js"
export * from "./mobile_CaseDemonstration.vue?vue&type=script&lang=js"
import style0 from "./mobile_CaseDemonstration.vue?vue&type=style&index=0&id=1b460b1b&prod&lang=scss&scoped=true"
import style1 from "./mobile_CaseDemonstration.vue?vue&type=style&index=1&id=1b460b1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b460b1b",
  null
  
)

export default component.exports